import React, { useEffect } from "react";

const BEHOLD_FEED_ID = "muOvN1ipwSrChxomPuqH";

export default function BeholdFeed() {
  useEffect(() => {
    if (window.__bhldScript) return;
    window.__bhldScript = true;
    const s = document.createElement("script");
    s.type = "module";
    s.src = "https://w.behold.so/widget.js";
    document.head.appendChild(s);
  }, []);

  return (
    <behold-widget feed-id={BEHOLD_FEED_ID} data-testid="behold-widget"></behold-widget>
  );
}
